import PlcNotifications from '../../../base/menu/airdome/PlcNotifications';

const plcNotifications: PlcNotifications = {
  categoryName: 'Notifikace PLC',
  current: 'Aktuální',
  archive: 'Archiv'
};

export default plcNotifications;
